import { useTranslation } from 'react-i18next';

import CircleCheck from '@/assets/icons/operational-dashboard/circle-check.svg?component';
import { Badge, type BadgeTone } from '@/components/atoms/Badge';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import type { TaskPriority, TaskStatus } from '@/domain/operationalDashboard';

interface TaskStatusBadgeProps {
    status: TaskStatus;
    priority: TaskPriority;
}

const PRIORITY_TONE: Record<TaskPriority, BadgeTone> = {
    critical: 'danger',
    high: 'elevated',
    warning: 'warning',
    low: 'success',
};

export default function TaskStatusBadge(props: TaskStatusBadgeProps) {
    const { status, priority } = props;
    const { t } = useTranslation();

    if (status === 'completed') {
        return (
            <Badge
                tone="success"
                icon={
                    <SvgIcon
                        icon={CircleCheck}
                        size="custom"
                        customSize={14}
                        color="currentColor"
                    />
                }>
                {t('operationalDashboard.task.completed')}
            </Badge>
        );
    }

    if (status === 'ignored') {
        return <Badge tone="neutral">{t('operationalDashboard.task.ignored')}</Badge>;
    }

    return (
        <Badge tone={PRIORITY_TONE[priority]}>
            {t(`operationalDashboard.priority.${priority}`)}
        </Badge>
    );
}
